import fetchUsers from '../../../Core/Services/fetchUsers'
import fetchProjectStatuses from '../../../Core/Services/fetchProjectStatuses'
import fetchProjectPhases from '../../../Core/Services/fetchProjectPhases'
import fetchProjects from '../../../Core/Services/fetchProjects'
import fetch from '../Services/fetch'
import { setAdditionalFilter } from '../State/additionalFilter'

export default function(props) {
  return function(dispatch) {
    // Store additionalFilter for componentView mode (e.g., filtering by project_id)
    dispatch(setAdditionalFilter((props && props.additionalFilter) || {}))

    dispatch(fetchUsers())
    dispatch(fetchProjectStatuses())
    dispatch(fetchProjectPhases())

    dispatch(fetchProjects())

    dispatch(fetch())
  }
}
